module.exports = __webpack_public_path__ + "media/35.b48e68ea.mp3";